const _getDictionary = async (wordpressUrl, endpoint) => {
  let dict = {}

  let pageNumber = 1,
    hasData = true
  while (hasData && pageNumber <= 10) {
    try {
      const res = await fetch(
        `${wordpressUrl}/wp-json/wp/v2/${endpoint}/?_fields[]=id&_fields[]=name&_fields[]=slug&_fields[]=taxonomy&_fields[]=lang&per_page=100&page=${pageNumber}`,
      )
      if (!res.ok) {
        hasData = false
        return dict
      }

      const data = await res.json()
      const uniqData = data
        .filter(d => d.lang === `en_gb`)
        .reduce(function (map, obj) {
          map[obj.slug] = { id: obj.id, name: obj.name }
          return map
        }, {})

      dict = { ...dict, ...uniqData }

      pageNumber++
      if (Object.keys(uniqData).length === 0) hasData = false
    } catch (_error) {
      console.error(_error)
      hasData = false
      return {}
    }
  }

  return dict
}

const getTagsDictionary = async wordpressUrl =>
  _getDictionary(wordpressUrl, `tags`)

const getCategoriesDictionary = async wordpressUrl =>
  _getDictionary(wordpressUrl, `categories`)

const _getFieldsStr = () => {
  return [
    `id`,
    `author`,
    `named_author`,
    `categories`,
    `date`,
    `title`,
    `slug`,
    `excerpt`,
    `tags`,
    `named_tags`,
    `named_categories`,
    `featured_media`,
    `fimg_url`,
    `link`,
  ]
    .map(s => `&_fields[]=${s}`)
    .join(``)
}

const getPosts = async (
  wordpressUrl,
  cats = [],
  catDictionary = [],
  tags = [],
  tagDictionary = [],
  token = null,
  pageNumber = 1,
  pageArticles = 3,
) => {
  const fieldsStr = _getFieldsStr()

  /*** !!! when search is OR !!! ***/
  // const catsStr = cats.reduce((acc, curr) => {
  //   if (catDictionary && catDictionary[curr] && catDictionary[curr].id)
  //     return `${acc}&categories[]=${catDictionary[curr].id}`
  //   return acc
  // }, ``)
  // const tagsStr = tags.reduce((acc, curr) => {
  //   if (tagDictionary && tagDictionary[curr] && tagDictionary[curr].id)
  //     return `${acc}&tags[]=${tagDictionary[curr].id}`
  //   return acc
  // }, ``)

  const searchStr = token && token.length ? `&search=${token}` : ``

  let catsIdentifiedCounter = 0
  let tagsIdentifiedCounter = 0
  const catsStr = cats.reduce((acc, curr) => {
    if (catDictionary && catDictionary[curr] && catDictionary[curr].id) {
      catsIdentifiedCounter++
      return `${acc}${acc.slice(-1) !== `=` ? `,` : ``}${
        catDictionary[curr].id
      }`
    }
    return acc
  }, `&categories[operator]=OR&categories[terms]=`)
  const tagsStr = tags.reduce((acc, curr) => {
    if (tagDictionary && tagDictionary[curr] && tagDictionary[curr].id) {
      tagsIdentifiedCounter++
      return `${acc}${acc.slice(-1) !== `=` ? `,` : ``}${
        tagDictionary[curr].id
      }`
    }
    return acc
  }, `&tags[operator]=OR&tags[terms]=`)

  if (cats.length && catsIdentifiedCounter === 0)
    return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }
  if (tags.length && tagsIdentifiedCounter === 0)
    return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }

  // console.log(cats, catDictionary, catsStr, searchStr)

  try {
    const res = await fetch(
      `${wordpressUrl}/wp-json/wp/v2/posts/?per_page=${pageArticles}&page=${pageNumber}${fieldsStr}${catsStr}${tagsStr}${searchStr}`,
    )
    if (!res.ok)
      return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }

    const data = await res.json()
    return {
      data,
      currentPage: pageNumber,
      numberOfPages: res.headers.get(`X-WP-TotalPages`),
      numberOfPosts: res.headers.get(`X-WP-Total`),
    }
  } catch (_error) {
    return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }
  }
}

const getPostsAdvanced = async (
  wordpressUrl,
  products = [],
  contentTypes = [],
  catDictionary = [],
  token = null,
  pageNumber = 1,
  pageArticles = 15,
) => {
  const fieldsStr = _getFieldsStr()

  const searchStr = token && token.length ? `&search=${token}` : ``

  const productsStr = products.reduce((acc, curr) => {
    if (catDictionary && catDictionary[curr] && catDictionary[curr].id)
      return `${acc}${acc.slice(-1) !== `=` ? `,` : ``}${
        catDictionary[curr].id
      }`
    return acc
  }, `&products=`)
  const contentTypesStr = contentTypes.reduce((acc, curr) => {
    if (catDictionary && catDictionary[curr] && catDictionary[curr].id)
      return `${acc}${acc.slice(-1) !== `=` ? `,` : ``}${
        catDictionary[curr].id
      }`
    return acc
  }, `&content_types=`)

  console.log(catDictionary, productsStr, contentTypesStr, searchStr)

  try {
    const res = await fetch(
      `${wordpressUrl}/wp-json/cubewise-search-api/v1/posts/?per_page=${pageArticles}&page=${pageNumber}${fieldsStr}${productsStr}${contentTypesStr}${searchStr}`,
    )
    if (!res.ok)
      return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }

    const data = await res.json()
    return {
      data,
      currentPage: pageNumber,
      numberOfPages: res.headers.get(`X-WP-TotalPages`),
      numberOfPosts: res.headers.get(`X-WP-Total`),
    }
  } catch (_error) {
    return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }
  }
}

const getPages = async (
  wordpressUrl,
  cats = [],
  catDictionary = [],
  tags = [],
  tagDictionary = [],
  token = null,
  pageNumber = 1,
  pageArticles = 3,
) => {
  const fieldsStr = _getFieldsStr()

  /*** !!! when search is OR !!! ***/
  // const catsStr = cats.reduce((acc, curr) => {
  //   if (catDictionary && catDictionary[curr] && catDictionary[curr].id)
  //     return `${acc}&categories[]=${catDictionary[curr].id}`
  //   return acc
  // }, ``)
  // const tagsStr = tags.reduce((acc, curr) => {
  //   if (tagDictionary && tagDictionary[curr] && tagDictionary[curr].id)
  //     return `${acc}&tags[]=${tagDictionary[curr].id}`
  //   return acc
  // }, ``)

  const searchStr = token && token.length ? `&search=${token}` : ``

  let catsIdentifiedCounter = 0
  let tagsIdentifiedCounter = 0
  const catsStr = cats.reduce((acc, curr) => {
    if (catDictionary && catDictionary[curr] && catDictionary[curr].id) {
      catsIdentifiedCounter++
      return `${acc}${acc.slice(-1) !== `=` ? `,` : ``}${
        catDictionary[curr].id
      }`
    }
    return acc
  }, `&categories[operator]=OR&categories[terms]=`)
  const tagsStr = tags.reduce((acc, curr) => {
    if (tagDictionary && tagDictionary[curr] && tagDictionary[curr].id) {
      tagsIdentifiedCounter++
      return `${acc}${acc.slice(-1) !== `=` ? `,` : ``}${
        tagDictionary[curr].id
      }`
    }
    return acc
  }, `&tags[operator]=OR&tags[terms]=`)

  if (cats.length && catsIdentifiedCounter === 0)
    return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }
  if (tags.length && tagsIdentifiedCounter === 0)
    return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }

  // console.log(cats, catDictionary, catsStr, searchStr)

  try {
    const res = await fetch(
      `${wordpressUrl}/wp-json/wp/v2/pages/?per_page=${pageArticles}&page=${pageNumber}${fieldsStr}${catsStr}${tagsStr}${searchStr}`,
    )
    if (!res.ok)
      return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }

    const data = await res.json()
    return {
      data,
      currentPage: pageNumber,
      numberOfPages: res.headers.get(`X-WP-TotalPages`),
      numberOfPosts: res.headers.get(`X-WP-Total`),
    }
  } catch (_error) {
    return { data: [], currentPage: 0, numberOfPages: 0, numberOfPosts: 0 }
  }
}

module.exports.WordpressApi = {
  getTagsDictionary: getTagsDictionary,
  getCategoriesDictionary: getCategoriesDictionary,
  getPosts: getPosts,
  getPostsAdvanced: getPostsAdvanced,
  getPages: getPages,
}
